import React from "react";

import ReactDOM from "react-dom";

import App from "./App";

class WebComponent extends HTMLElement {
  connectedCallback() {
    const componentType = this.getAttribute("componentType");

    ReactDOM.render(<App componentType={componentType} />, this);
  }
}

const ELEMENT_ID = "voebiz-react-category-benefits";

if (!customElements.get(ELEMENT_ID)) {
  customElements.define(ELEMENT_ID, WebComponent);
}
